import { useGLTF } from '@react-three/drei';
import * as global from "../../data/global";

export function An6(props) {
    const { nodes } = useGLTF('3ds/an/An6.gltf')
    return (
        <group {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (!global.gw.geometries.An6) {
                        global.gw.geometries.An6 = e.geometry;
                    }
                }}
                name="An6"
                geometry={nodes.An6.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/An6.gltf');